enum SampleFormat {
    STANDARD = 'STANDARD',
    G_CLASS = 'G_CLASS',
    MAYBACH = 'MAYBACH',
}

export default SampleFormat;